import MainLayoutComponent from '@/components/layouts/main-layout/main-layout.component';
import {PERMISSION_KEYS} from '@/globals';
import {helpers} from '@/plugins/helpers/helpers';
import {AlertService, UserSession} from '@/sdk';
// import {UserSetupRoutes} from '@/views/user-setup/routes/user-setup.routes';
import {AccountRoutes} from '@/views/account/account.routes';
import {AdminPanelRoutes} from '@/views/admin-panel/admin-panel.routes';
import {AuthenticationRoutes} from '@/views/authentication/routes/authentication.routes';
import {ClientRoutes} from '@/views/client/client.routes';
import DigitalTwinCanvasComponent from '@/views/client/digital-twin/digital-twin-canvas/digital-twin-canvas.component';
import {JobReportRoutes} from '@/views/job-report/routes/job-report.routes';
import {JobSetupRoutes} from '@/views/job-setup/routes/job-setup.routes';
import {PaymentRoutes} from '@/views/payment/payment.routes';
import {PolicyRoutes} from '@/views/policy/routes/policy.routes';
import {RolesService} from '@/views/shared/services';
import {TeamSetupRoutes} from '@/views/team-setup/routes/team-setup.routes';
import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import goTo from 'vuetify/lib/services/goto';

Vue.use(VueRouter);

// for (const lang of LANGUAGES) {
//     new TranslationsApi().GetLangMessages(lang.key).then(res => {
//         // console.log('setting locale message: ', lang.key, res);
//         i18n.setLocaleMessage(lang.key, res);
//     });
// }

const routes: Array<RouteConfig> = [
    ...ClientRoutes,

    ...PolicyRoutes,

    ...AccountRoutes,
    ...PaymentRoutes,

    ...AuthenticationRoutes,
    // ...SiteSeuptRoutes,
    ...JobSetupRoutes,
    ...TeamSetupRoutes,
    ...JobReportRoutes,
    // ...UserSetupRoutes,
    ...AdminPanelRoutes,

    {
        path: '/digital-twin/:siteLocationId',
        name: 'digital-twin-area',
        component: DigitalTwinCanvasComponent,
        props: true,
        meta: {
            title: 'Digital Twin Area',
            description: 'Digital Twin Area page',
        },
    },

    {
        path: '*',
        component: MainLayoutComponent,
        // children: [
        //     {
        //         path: '*',

        //         name: 'Page Not Found',
        //         component: PageNotFoundComponent,
        //         meta: {
        //             title: 'Error',
        //             robots: 'Content=noindex, nofollow'
        //         }
        //     }
        // ]
    },
];

// const router = new VueRouter({
//     mode: 'history',
//     base: process.env.BASE_URL,
//     scrollBehavior: (to, from, savedPosition) => {
//         let scrollTo: any = 0;

//         if (to.hash) {
//             scrollTo = to.hash;
//         } else if (savedPosition) {
//             scrollTo = savedPosition.y;
//         }

//         return goTo(scrollTo);
//     },
//     routes,
// });

const UserSessionSrv = new UserSession();

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo: any = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
    routes,
});

/**
 * Helper function to check if user has required permissions
 * Uses the existing helpers.hasPermission function
 * @param permissions Array of permission keys to check
 * @param siteId Site ID from route params
 * @returns true if user has at least one of the required permissions
 */
function hasRequiredPermissions(permissions: Array<PERMISSION_KEYS>, siteId?: string | null): boolean {
    if (!permissions || permissions.length === 0) {
        return true; // No permissions required
    }

    // Check if user has any of the required permissions using the helper function
    return permissions.some(permission => helpers.hasPermission(permission, siteId));
}

/**
 * Extract siteId from route params
 * @param route Route to extract siteId from
 * @returns siteId or null
 */
function extractSiteId(route: any): string | null {
    return route.params.siteId || null;
}

router.beforeEach(async (to, from, next) => {
    // Get current user from cookie.
    const isUserLoggedIn = UserSessionSrv.isUserAuthenticated;
    // new ApiAuth().SessionValue && !!new ApiAuth().SessionValue!.UserId;

    const nonAuthRoute = [
        'auth',
        'signin',
        'signup',
        'Forgot Password',
        'forgotPassword',
        'resetPassword',
        'Resend Email',
        'Cancelled Membership',
        'policy',
        'refund-policy',
        'phoneVerification',
    ];
    const nonPaymentRoutes = ['Payment', 'Checkout', 'SubscriptionPlan', 'Payment Success', 'Payment Fail'];

    const isNonAuthRoute = nonAuthRoute.includes(to.name!);
    const isNonPaymentRoute = nonPaymentRoutes.includes(to.name!);

    const parentRouteNames = routes.map(route => {
        return route.name;
    });
    const childRoutes: any = [];

    function findingRouteNames(routes: Array<RouteConfig>) {
        routes.forEach(route => {
            if ('children' in route) {
                findingRouteNames(route.children!);
            } else {
                childRoutes.push(route.name);
            }
        });
    }
    findingRouteNames(routes);

    // const allRouteNames = [...parentRouteNames, ...childRoutes];
    // const isRouteExist = allRouteNames.includes(to.name);
    const isPublicRoute = [
        'accountCreation',
        'Page Not Found',
        'informationDetails',
        'informationDetailsArea',
        'informationDetailsSub',
        'informationDetailsEquipment',
        'searchSite',
        'buttonBar',
        'header',
        'digital-twin-area',
        'policy',
        'refund-policy-en',
        'refund-policy-kr',
        'unauthorized',
        'admin-unauthorized',
    ].includes(to.name!);

    // new FilterService().Filter.Status = null;
    // new StateService();

    // if (!isRouteExist) {
    //     console.log(allRouteNames);

    //     next({name: 'Page Not Found'});
    // } else
    // Perform Authentication

    // console.log('route exists: ', isRouteExist);
    // if (!isRouteExist) {
    //     next({name: 'Page Not Found'});
    // } else
    if (isPublicRoute) {
        next();
    } else if (!isUserLoggedIn && isNonAuthRoute) {
        next();
    } else if (isUserLoggedIn && isNonAuthRoute) {
        next({name: 'sites-list', query: {...to.query, redirect_reason: 'UNAUTHORIZIED'}});
    } else if (!isUserLoggedIn && !isNonAuthRoute) {
        next({name: 'signin', query: {redirect_reason: 'UNAUTHORIZIED'}});
    } else {
        // Wait for payment status to load if user is authenticated and payment status hasn't loaded yet
        if (isUserLoggedIn && !UserSessionSrv.paymentStatusLoaded$.value) {
            new RolesService();
            // Wait for payment status to be loaded
            await new Promise<void>(resolve => {
                const subscription = UserSessionSrv.paymentStatusLoaded$.subscribe(loaded => {
                    if (loaded) {
                        subscription.unsubscribe();
                        resolve();
                    }
                });

                // Set a timeout to prevent indefinite waiting (e.g., 10 seconds)
                setTimeout(() => {
                    subscription.unsubscribe();
                    resolve();
                }, 10000);
            });
        }

        // Check payment status before proceeding
        if (!isNonPaymentRoute) {
            const paymentStatus = UserSessionSrv.paymentStatus$.value;
            if (!paymentStatus.isPaymentDone) {
                // Redirect to SubscriptionPlan if payment is not done
                next({name: 'SubscriptionPlan'});
                new AlertService().show('warning', 'Please complete your subscription to access this page.');
                return;
            }
        }

        // Wait for permissions to load if user is authenticated and permissions haven't loaded yet
        if (isUserLoggedIn && !UserSessionSrv.permissionsLoaded$.value) {
            new RolesService();
            // Wait for permissions to be loaded
            await new Promise<void>(resolve => {
                const subscription = UserSessionSrv.permissionsLoaded$.subscribe(loaded => {
                    if (loaded) {
                        subscription.unsubscribe();
                        resolve();
                    }
                });

                // Set a timeout to prevent indefinite waiting (e.g., 10 seconds)
                setTimeout(() => {
                    subscription.unsubscribe();
                    resolve();
                }, 10000);
            });
        }

        // Check permissions if route has permissions meta
        if (to.meta && to.meta.permissions && Array.isArray(to.meta.permissions)) {
            const siteId = extractSiteId(to);
            const hasPermission = hasRequiredPermissions(to.meta.permissions, siteId);

            if (!hasPermission) {
                // User doesn't have required permission
                // Check if the route is within admin-panel
                const isAdminRoute = to.path.startsWith('/admin-panel');
                next({name: isAdminRoute ? 'admin-unauthorized' : 'unauthorized'});
                return;
            }
        }

        next();
    }

    // scrollToTop();
});

export default router;
